import './en.win'; // 40%
import './es-latin.win';
import './en-in.win';
import './de.win';
import './en-uk.win';
import './fr.win';
import './pt-br.win';
import './es.win';
import './en-intl.win';
import './ru.win';
import './pl.win';
import './it.win';
import './sv.win';
import './tr.win';
import './pt.win';
import './dk.win';
import './no.win';
import './thai.win';
import './hu.win';
import './de-swiss.win';
import './en-belgian.win';
import './cz.win';

export { KeyboardLayoutContribution } from './_.contribution';
